import React from "react";
import { t } from "../i18n";

// Attente : même roue, même centrage, partout. `full` occupe l'écran (écran
// d'entrée), sinon le bloc se centre dans la place qu'on lui laisse.
function Loading({ label, full = false }) {
  return (
    <div className={`pq-loading${full ? " full" : ""}`}>
      <div className="pq-loading-ring" />
      <span className="pq-loading-label">{label || t("common.loading")}</span>
    </div>
  );
}

export default Loading;
